import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { urlApi } from '../../../utils/apiConfig';


interface IChannel {
  nomefila: string;
  queueId: number;
  apiKey: string;
  type: 'NORMAL' | 'APIOFICIAL';
  fire: number;
}

@Injectable()
export class ConfiguracoesService {
   

  constructor(private http: HttpClient) {

   }  


  public getChannelsConfigured(documentClient: string): Observable<any>{
    return this.http.get(`${urlApi}/admin/configuracoes/${documentClient}`);
  }

  public deleteChannelsConfigured(idFila: number):  Observable<any>{
    return this.http.delete(`${urlApi}/admin/configuracoes/${idFila}`);
  }

  public setChannelClient(objectDataChannel: IChannel): Observable<any>{
    return this.http.post(`${urlApi}/admin/configuracoes`, objectDataChannel)
  }
}
